import React, {Component} from "react"
import {Grid} from "react-bootstrap"

import RewardsLanesQuery, {HomePageRewardsLanesQueryResult as QueryResult} from "@irati/reward/apollo/query/HomePageRewardsLanes"
import FeedSlider from "@irati-web/reward/src/components/FeedSlider"
import {NoResults} from "@irati-web/reward/src/components/List"
import {RewardsRouteProps} from "@irati-web/reward/src/types"
import {RewardSuccessPopup} from "@irati-web/reward/src/components/Success"
import {rewardTracking} from "@irati-tracking/reward"
import RewardBanner from "@irati-web/reward/src/components/Banner"

import Layout from "@irati-web/recognition/src/components/Layout"
import bannerImg from "@irati-web/recognition/src/images/banner.png"
import {RewardOrder} from "@irati/types"
import RewardService from "@irati/reward/apollo/Reward"

interface Props extends RewardsRouteProps {
  match: any
}

interface State {
  rewardOrder?: RewardOrder
}

class RecognitionRewards extends Component<Props, State> {
  state: State = {}

  componentDidMount() {
    const {
      params: {uuid}
    } = this.props.match
    if (uuid) {
      RewardService.getRewardOrder(uuid).then((rewardOrder: RewardOrder) => {
        this.setState({rewardOrder})
      })
    }
    rewardTracking.rewardsTabHome()
  }

  handleClearOrder = () => {
    this.setState({
      rewardOrder: undefined
    })
  }

  render() {
    const {rewardOrder} = this.state

    return (
      <Layout bannerImg={bannerImg} bannerChild={<RewardBanner />}>
        <Grid>
          <RewardsLanesQuery>
            {({data: {homePageRewardsLanes: lanes}}: QueryResult) => {
              if (!lanes.length) {
                return <NoResults />
              }

              return lanes.map((lane, index) => (
                <FeedSlider
                  isFirst={index === 0}
                  key={index}
                  id={`reward-slider-${index}`}
                  title={lane.tags.map((tag) => tag.name).join(" & ")}
                  data={lane.rewards}
                />
              ))
            }}
          </RewardsLanesQuery>
        </Grid>

        {rewardOrder && <RewardSuccessPopup rewardOrder={rewardOrder} redirectToFeed onAfterExitModal={this.handleClearOrder} />}
      </Layout>
    )
  }
}

export default RecognitionRewards
